import React from "react";

const Gallery: React.FC = () => {
  return <div>Gallery</div>;
};

export default Gallery;
